module.exports = __webpack_public_path__ + "static/img/earn-big.bcd6da2d.png";